'use-strict'
import app from '../../../data/base';
import moment, { normalizeUnits } from 'moment';

const validateRequiredField = (inputvalue) => {
    if(inputvalue==null || inputvalue==''){
        return false;
    }else
        return true;
}

const validateUtente = (inputobject, isedit) => {
    const result = [];
    // if(!validateRequiredField(inputobject.enabled)){
    //     result.push({field : 'Abilitato', error : 'Campo obbligatorio'});
    // }
    if(inputobject.role && inputobject.role['id'] && !validateRequiredField(inputobject.role.id)){
        result.push({field : 'Ruolo', error : 'Campo obbligatorio'});
    }
    if(!validateRequiredField(inputobject.name)){
        result.push({field : 'Nome', error : 'Campo obbligatorio'});
    }
    if(!validateRequiredField(inputobject.surname)){
        result.push({field : 'Cognome', error : 'Campo obbligatorio'});
    }
    if(!validateRequiredField(inputobject.username)){
        result.push({field : 'Username', error : 'Campo obbligatorio'});
    }
    if(!isedit){
        if(!validateRequiredField(inputobject.password)){
            result.push({field : 'Password', error : 'Campo obbligatorio'});
        }
    }
    
    return result;

}

const saveUtente = async (inputobject,id) => {
    try{
        const body =  `${JSON.stringify(inputobject)}`;

        const response = await app.methods.callserver('api/admin/user','POST',null,body,true);
        console.log(response)
        if(response.status=='201' || response.status=='200'){
            // const data = await response.json();

            //if(response.statusText== "Saved")
                return true;
            //else
            //    return false;
        }else{
            return false;
        }

    }catch(err){
        console.log('Error during saveUtente');
        console.log(err);
        return false;
    }
}


const deleteUtente = async (idutente) => {
    try{
        console.log(idutente);
        const response = await app.methods.callserver('api/admin/user/' + idutente,'DELETE',false, null);
        console.log(response)
        if(response.status=='201' || response.status=='200'){
            return true;
        }else{
            return false;
        }

    }catch(err){
        console.log('Error during saveUtente');
        console.log(err);
        return false;
    }
}




const utenti = {
    auth: {
        onAuthStateChanged: app.auth.onAuthStateChanged
    },
    methods : {
      callserver : app.methods.callserver,
      saveUtente : saveUtente,
      validateUtente : validateUtente,
      deleteUtente : deleteUtente

    }
  };
  export default utenti;
